import { Loading } from '@salescore/client-common'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { type ReactElement, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// eslint-disable-next-line sonarjs/todo-tag
// TODO: このエンドポイントは使われてないのでは？
const Page = (): ReactElement => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  // const organizationId = getCurrentOrganizationIdFromLocalStorage()

  useEffect(() => {
    void navigate({ to: '/' })
    // if (organizationId === null) {
    //   void navigate({ to: '/' })
    // } else {
    // eslint-disable-next-line sonarjs/todo-tag
    //   // TODO: 存在しないページへのredirectとなっている。
    //   void navigate({
    //     to: '/o/$organizationId/settings/integrations',
    //     params: { organizationId },
    //     search: window.location.search,
    //   })
    // }
  }, [navigate])

  return <Loading message={t(`認証中...`)} />
}

export const Route = createFileRoute('/callback/integration')({
  component: Page,
})
